const parseNextQuery = (input: string | string[] | undefined) =>
  // eslint-disable-next-line no-nested-ternary
  input === undefined ? [] : Array.isArray(input) ? input : [input]

export default parseNextQuery
